import React from 'react';
import * as R from 'ramda';
import { Badge, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  title: {
    fontWeight: 'bold',
    marginBottom: '4px',
    paddingRight: '55px',
  },
  path: {
    fontSize: '0.75rem',
    color: '#666',
    paddingRight: '60px',
  },
  badge: {
    '& .MuiBadge-badge': {
      top: 8,
      right: 8,
      padding: '4px 5px',
      fontSize: '0.7rem',
      height: 'auto',
      borderRadius: '12px',
      fontWeight: '500',
    },
  },
});

const DeliveryTitle = ({ record }) => {
  const classes = useStyles();

  const unit =
    R.pathOr('', ['path', 3, 'display_name'], record) ||
    record?.unitTitle ||
    '';
  const submodule = R.pathOr('', ['path', 2, 'display_name'], record);

  const titleBlock = (
    <div>
      <div className={classes.title}>{unit}</div>
      {submodule ? <div className={classes.path}>{submodule}</div> : null}
    </div>
  );

  return (
    <div className={classes.container}>
      {record.required ? (
        <Badge
          className={classes.badge}
          color="primary"
          badgeContent="Required"
          overlap="rectangular"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {titleBlock}
        </Badge>
      ) : (
        titleBlock
      )}
    </div>
  );
};

export default DeliveryTitle;
